(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('ValidatorHelper', ValidatorHelper)

    /** @ngInject */
    function ValidatorHelper() {
        const ValidatorHelper = {
            validateDate,
            validateCPF,
            validateUrl,
            validatePassword
        };

        return ValidatorHelper;

        function validateDate(date) {
            let cleanDate = date.replace(/[//"]/g, '-');
            let splitDate = cleanDate.split('-');
            let formattedDate = null;

            if (splitDate[0].length == 2)
                formattedDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
            else
                formattedDate = `${splitDate[0]}-${splitDate[1]}-${splitDate[2]}`;

            return moment(formattedDate).isValid();
        }

        function validateCPF(cpf) {
            if (cpf) {
                cpf = cpf.replace(/[\.-]/g, "");

                var numbers, chars, sum, i, result, sameNumbers;
                sameNumbers = 1;

                if (cpf.length < 11)
                    return false;

                for (i = 0; i < cpf.length - 1; i++)
                    if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                        sameNumbers = 0;
                        break;
                    }

                if (!sameNumbers) {
                    numbers = cpf.substring(0, 9);
                    chars = cpf.substring(9);
                    sum = 0;

                    for (i = 10; i > 1; i--)
                        sum += numbers.charAt(10 - i) * i;

                    result = sum % 11 < 2 ? 0 : 11 - sum % 11;

                    if (result != chars.charAt(0))
                        return false;

                    numbers = cpf.substring(0, 10);
                    sum = 0;

                    for (i = 11; i > 1; i--)
                        sum += numbers.charAt(11 - i) * i;

                    result = sum % 11 < 2 ? 0 : 11 - sum % 11;

                    if (result != chars.charAt(1))
                        return false;

                    return true;
                }

                return false;
            }

            return false;
        }

        function validateUrl(url) {
            const urlPattern = new RegExp('^((ft|htt)ps?:\\/\\/)?' + // Protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // Domain name and extension
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // Or ip (v4) address
                '(\\:\\d+)?' + // Port
                '(\\/[-a-z\\d%@_.~+&:]*)*' + // Path
                '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // Query string
                '(\\#[-a-z\\d_]*)?$', 'i');

            return urlPattern.test(url);
        }

        function validatePassword(password) {
            if (!password)
                return false;

            if (password.length < 8)
                return 'A senha deve conter ao menos 8 caracteres';

            if (!password.match(/[A-Z]/))
                return 'A senha deve conter ao menos um caracter maiúsculo';

            if (!password.match(/[0-9]/))
                return 'A senha deve conter ao menos um caracter numérico';

            return true;
        }
    }
}());